function checkSelectRepeatOrder() {
  const repeatItemList = JSON.parse(localStorage.getItem('recommendationRepeatItemList'));
  let bool = [];
  for (var i = 0; i < repeatItemList.length; i++) {
    var bcItemList = repeatItemList[i].bcItemList;
    for (var j = 0; j < bcItemList.length; j++) {
      bool.push(bcItemList[j].itemList.some(val => val.repeatOrder));
    }
  }

  let result = bool.some(val => val);
  return result;
}
export default {
  checkSelectRepeatOrder,
}



// WEBPACK FOOTER //
// ./src/model/checkSelectMultiRepeatOrder.js